export const FormInteractiveEmailWidgetId = 'FormInteractiveEmailWidget';

export enum FormInteractiveEmailWidgetAttributes {
  FORM_CONTROL_NAME = 'formControlName',
  FORM_CONTROL_VALUE = 'formControlValue',
  EMAIL = 'email',
}
